import * as Actions from '../action';

const initialGlobal = {
  loading: false,
  socket: null,
  collapseItems: false
};

const initialState = {
  allData: [],
  allDataExpedientV2: [],
  data: [],
  total: 1,
  params: {},
  selectedExpedient: null,
  selectExpedient: null,
  global: initialGlobal
};

const expedientCombined = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_DATA_EXPEDIENTSV1_LEASE':
      return {
        ...state,
        allDataExpedientV2: action.data
      };
    case 'GET_ALL_DATA_EXPEDIENT':
      return { ...state, allData: action.data };
    case 'GET_DATA_EXPEDIENT':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      };
    case 'GET_EXPEDIENT':
      return { ...state, selectedExpedient: action.selectedExpedient };
    case 'ADD_EXPEDIENT':
      return { ...state };
    case 'DELETE_EXPEDIENT':
      return { ...state };
    case 'GET_NEST_EXPEDIENT':
      return { ...state, selectExpedient: action.data };
    case Actions.SET_LOADING_V2:
      return { 
        ...state,
        global: { ...state.global, loading: action.payload }
      };
    case Actions.SET_COLLAPSE_MENU_V2:
      return { 
        ...state,
        global: { ...state.global, collapseItems: action.payload }
      };
    default:
      return { ...state };
  }
};

export default expedientCombined;
